import { http } from "shared/api/http";

export interface ILookupValue {
  id: string;
  organizationId: string;
  category: string;
  value: string;
  label: string;
  isDefault: boolean;
  isActive: boolean;
  sortOrder: number;
}

const apiPath = `${process.env.REACT_APP_API_BASE_URL}/api/v1/lookups`;

export const getLookups = async () => {
  const res = await http.get<ILookupValue[]>(`${apiPath}`);
  return res?.data;
};

export const getLookupsByCategory = async (category: string, includeInactive = false) => {
  const res = await http.get<ILookupValue[]>(`${apiPath}/${category}`, {
    params: includeInactive ? { includeInactive: "true" } : undefined,
  });
  return res?.data;
};

export const createLookup = async (data: {
  category: string;
  value: string;
  label: string;
  sortOrder?: number;
}) => {
  try {
    const res = await http.post<ILookupValue>(`${apiPath}`, data);
    return res?.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const updateLookup = async (
  id: string,
  data: {
    label?: string;
    isActive?: boolean;
    sortOrder?: number;
  }
) => {
  try {
    const res = await http.put<ILookupValue>(`${apiPath}/${id}`, data);
    return res?.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const deleteLookup = async (id: string) => {
  try {
    const res = await http.delete<{ success: boolean }>(`${apiPath}/${id}`);
    return res?.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const seedDefaults = async () => {
  try {
    const res = await http.post<{ success: boolean }>(`${apiPath}/seed`);
    return res?.data;
  } catch (error) {
    return Promise.reject(error);
  }
};
